// Dominican Republic convention: DD/MM/YYYY, on the Dominican calendar (UTC−4 all year) whatever the computer's own
// language or time zone — see ECOSYSTEM.md §6 rule 11. Never toLocaleDateString() / toLocaleString() without these:
// on a PC set to English they print 9/30/2026.
const TZ = 'America/Santo_Domingo';
const DAY_MS = 24 * 60 * 60 * 1000;

// For date-only fields stored as UTC midnight (lastDone, nextDueDate,
// expirationDate) — read UTC components so the date doesn't shift a day in
// timezones behind UTC.
export const formatDateOnly = (isoString) => {
  const d = new Date(isoString);
  const day = String(d.getUTCDate()).padStart(2, '0');
  const month = String(d.getUTCMonth() + 1).padStart(2, '0');
  return `${day}/${month}/${d.getUTCFullYear()}`;
};

// The Dominican day of a timestamp, "YYYY-MM-DD" — sortable, for grouping by day (charts). Show it with dayLabel.
export const dayKeyDR = (value) => new Date(value).toLocaleDateString('en-CA', { timeZone: TZ });

// "30/09/2026" for any stored date: a bare date (midnight UTC) is its own day, a timestamp its Dominican day.
export const formatDay = (value, fallback = '—') => {
  if (value === null || value === undefined || value === '') return fallback;
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value.split('-').reverse().join('/');
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return fallback;
  return d.getTime() % DAY_MS === 0 ? formatDateOnly(d) : dayKeyDR(d).split('-').reverse().join('/');
};

// "30/09" — a day key (YYYY-MM-DD) as a short chart label.
export const dayLabel = (key) => `${key.slice(8, 10)}/${key.slice(5, 7)}`;

// For real timestamps (event times, "last seen", etc.) — Dominican time, DD/MM/YYYY HH:MM.
export const formatDateTime = (isoString, fallback = '—') => {
  if (isoString === null || isoString === undefined || isoString === '') return fallback;
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return fallback;
  const time = d.toLocaleTimeString('es-DO', { timeZone: TZ, hour: '2-digit', minute: '2-digit' });
  return `${formatDay(d)} ${time}`;
};
